/**
 * Request body for `PUT /api/users/me/billing` (MVP-10, tightened in MVP-40).
 * Mirrors the backend `UpdateBillingRequest` DTO — all 7 fields are now
 * required server-side. The form blocks submit before the BE 400 fires.
 */
export interface IBillingUpdateRequest {
  fullName: string;
  billingDepartment: string;
  billingStreet: string;
  billingZip: string;
  billingCity: string;
  billingCountryId: number;
  invoicingEmail: string;
}
